import { render, staticRenderFns } from "./PlumbingCAD.vue?vue&type=template&id=180d1998&scoped=true"
import script from "./PlumbingCAD.vue?vue&type=script&lang=js"
export * from "./PlumbingCAD.vue?vue&type=script&lang=js"
import style0 from "./PlumbingCAD.vue?vue&type=style&index=0&id=180d1998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d1998",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QIcon});
